import React from 'react';
import PropTypes from 'prop-types';
import './ComponentTitle.scss';


class ComponentTitle extends React.Component {
  render() {
    return (
      <div className="componentTitle">
        {this.props.text}
      </div>
    )
  }
}

ComponentTitle.prototypes = {
  text: PropTypes.string,
};

export default ComponentTitle;